'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _Hubs = require('self-service-api/constants/Hubs');

var _SeatsPicker = require('pricing-pages-unified-ui/components/common/SeatsPicker');

var _SeatsPicker2 = _interopRequireDefault(_SeatsPicker);

var _ContactsPicker = require('pricing-pages-unified-ui/components/common/ContactsPicker');

var _ContactsPicker2 = _interopRequireDefault(_ContactsPicker);

var _SuiteEditionMerchIdMap = require('pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap');

var _SuiteEditionMerchIdMap2 = _interopRequireDefault(_SuiteEditionMerchIdMap);

var _GrowthSuiteEditionTermIdMap = require('pricing-pages-unified-ui/constants/GrowthSuiteEditionTermIdMap');

var _GrowthSuiteEditionTermIdMap2 = _interopRequireDefault(_GrowthSuiteEditionTermIdMap);

var _CalculatorDivider = require('pricing-pages-unified-ui/components/calculator/CalculatorDivider');

var _CalculatorDivider2 = _interopRequireDefault(_CalculatorDivider);

var _H = require('UIComponents/elements/headings/H5');

var _H2 = _interopRequireDefault(_H);

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuiteAdditionalUnitsPicker = function SuiteAdditionalUnitsPicker(_ref) {
  var activeEdition = _ref.activeEdition,
      activeTerm = _ref.activeTerm,
      additionalUnitQuantities = _ref.additionalUnitQuantities,
      setAdditionalUnitQuantity = _ref.setAdditionalUnitQuantity;

  var termId = _GrowthSuiteEditionTermIdMap2.default[activeEdition][activeTerm];

  var HubToMerchIdsMap = _SuiteEditionMerchIdMap2.default[activeEdition];

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(_ContactsPicker2.default, {
      moreDetailsGAClassName: (0, _publicPageUrls.getGAClassName)('growth-pricing-startercontacts'),
      className: 'm-y-7',
      merchandiseId: HubToMerchIdsMap[_Hubs.HUB_MARKETING],
      additionalUnitQuantity: additionalUnitQuantities[_Hubs.HUB_MARKETING],
      onChange: function onChange(quantity) {
        return setAdditionalUnitQuantity({ marketingUnits: quantity });
      },
      termId: termId
    }),
    _react2.default.createElement(_CalculatorDivider2.default, null),
    _react2.default.createElement(
      _H2.default,
      { className: 'm-bottom-6' },
      _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.seats.title' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'm-bottom-6' },
      _react2.default.createElement(_SeatsPicker2.default, {
        merchandiseId: HubToMerchIdsMap[_Hubs.HUB_SALES],
        additionalUnitQuantity: additionalUnitQuantities[_Hubs.HUB_SALES],
        onChange: function onChange(quantity) {
          return setAdditionalUnitQuantity({ salesUnits: quantity });
        },
        termId: termId,
        hideFreeUsersDisclaimer: true,
        useHubSpecificTitle: true
      })
    ),
    _react2.default.createElement(_SeatsPicker2.default, {
      merchandiseId: HubToMerchIdsMap[_Hubs.HUB_SERVICE],
      additionalUnitQuantity: additionalUnitQuantities[_Hubs.HUB_SERVICE],
      onChange: function onChange(quantity) {
        return setAdditionalUnitQuantity({ serviceUnits: quantity });
      },
      termId: termId,
      hideFreeUsersDisclaimer: false,
      useHubSpecificTitle: true
    })
  );
};

SuiteAdditionalUnitsPicker.propTypes = {
  activeEdition: _react.PropTypes.string.isRequired,
  activeTerm: _react.PropTypes.string.isRequired,
  additionalUnitQuantities: _react.PropTypes.object.isRequired,
  setAdditionalUnitQuantity: _react.PropTypes.func.isRequired
};

exports.default = SuiteAdditionalUnitsPicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteAdditionalUnitsPicker.js
// module id = 784
// module chunks = 3 4